import { apiRequest } from './apiClient';
import { getAgentData, getUserId } from '../../../services/util';

let reqCounter = 0;

const getDefaultAgentPayload = () => {
    reqCounter++;
    return { ns: 'ozonetel.cloudagent', utid: reqCounter }
}
const chatService = {

    conversations: {
        getById: (id, signal, name) => {
            let agentData = getAgentData();
            return apiRequest.post('', {
                ...getDefaultAgentPayload(),
                "type": "tbGetSubUserChatHist",
                customer: agentData?.customer || '',
                userId: getUserId(),
                agentUniqId: agentData?.agentUniqId || '',
                subUserId: id,
                agentId: agentData?.agentInfo?.agentId || '',
                subUserName: name
            }, { signal });

        },
    },

    messages: {
        send: (payload) => {
            let agentData = getAgentData();
            return apiRequest.post('', {
                ...getDefaultAgentPayload(),
                type: 'tbSendMsgToSubUser',
                agentUniqId: agentData?.agentUniqId || '',
                userId: getUserId(),
                agentId: agentData?.agentInfo?.agentId || '',
                customer: agentData?.customer || '',
                ...payload
            });

        },
    },
    search: {
        query: (signal) => {
            reqCounter++;
            let agentData = getAgentData();
            return apiRequest.post('', {
                ...getDefaultAgentPayload(),
                type: 'tbGetSubUserList',
                customer: agentData?.customer || '',
                userId: getUserId(),
                agentId: agentData?.agentInfo?.agentId || '',
                agentUniqId: agentData?.agentUniqId || '',
            }, { signal });

        },
    },
    getRecentSubUsersList: {
        send: (payload) => {
            let agentData = getAgentData();
            return apiRequest.post('', {
                ...getDefaultAgentPayload(),
                type: 'tbGetRecentSubUsers',
                agentUniqId: agentData?.agentUniqId || '',
                userId: getUserId(),
                agentId: agentData?.agentInfo?.agentId || '',
                customer: agentData?.customer || '',
                ...payload
            });

        },
    }
};

export default chatService; 